export default __webpack_public_path__ + "static/media/discord.4b46d06e.svg";